import React, { useEffect, useState } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { Input } from "reactstrap";
import { isLoggedIn } from "../../utils";
import "./Home.css";

const Home = () => {
  const history = useHistory();
  const [accessCode, setAccessCode] = useState("");

  useEffect(() => {
    // initialize from URL if present
    const params = new URLSearchParams(history.location.search);
    const existing = params.get("accessCode") || "";
    if (existing) setAccessCode(existing);
  }, [history.location.search]);

  const handleSignIn = () => {
    history.push("/login");
  };

  const handleRegister = () => {
    history.push("/register");
  };

  const handlePublicGroups = () => {
    history.push("/public");
  };

  const pushAccessCode = (value) => {
    const params = new URLSearchParams(history.location.search);

    if (value && value.trim() !== "") params.set("accessCode", value.trim());
    else params.delete("accessCode");

    const search = params.toString();
    history.push({ pathname: "/", search: search ? `?${search}` : "" });
  };

  if (isLoggedIn()) {
    return <Redirect to="/public" />;
  }

  return (
    <div className="home-root">
      <header>
        <div className="brand">
          <img src="/bg-logo.jpg" alt="BuyGroup Logo" />
        </div>
        <div className="header-actions">
          <button className="btn ghost" onClick={handleSignIn}>
            Sign in
          </button>
          <button className="btn primary" onClick={handleRegister}>
            Create free account
          </button>
        </div>
      </header>

      <section className="hero">
        <h1>Unlock better pricing with free membership</h1>
        <p>
          BuyGroup lets small businesses band together to get the things they
          need to buy the most, for less! Sign up free and start saving today.
        </p>
        <button className="btn primary btn-width" onClick={handleRegister}>
          Create free account
        </button>
        <div className="my-2">OR</div>
        <button className="btn ghost btn-width" onClick={handlePublicGroups}>
          Browse public groups
        </button>
        <div className="my-2">OR</div>
        <Input
          type="text"
          placeholder="Enter Access Code"
          name="accessCode"
          className="mx-auto btn-width"
          value={accessCode}
          onChange={(e) => setAccessCode(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              pushAccessCode(accessCode);
            }
          }}
        />
      </section>
    </div>
  );
};

export default Home;
